import React from 'react';
import YSaatioPageContainer from '../YSaatioPageContainer';
import { RouteComponentProps } from 'react-router';
import { TerminationNoticeForm } from './TerminationNoticeForm';

const YSaatioTerminationFormPage = (pageProps: RouteComponentProps) => {
  return (
    <YSaatioPageContainer history={pageProps.history}>
      <TerminationNoticeForm afterSubmit={(url) => (window.location.href = url)} />
    </YSaatioPageContainer>
  );
};

export default YSaatioTerminationFormPage;
